<template>
  <ContentWrap>
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="68px"
    >
      <el-form-item label="标题" prop="title">
        <el-input
          v-model="queryParams.title"
          class="!w-240px"
          clearable
          placeholder="请输入标题"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="媒体类型" prop="mediaType">
        <el-select
          :model-value="queryParams.mediaType as any"
          @update:model-value="(val: any) => queryParams.mediaType = val"
          class="!w-240px"
          clearable
          placeholder="请选择媒体类型"
        >
          <el-option label="图片" value="IMAGE" />
          <el-option label="视频" value="VIDEO" />
          <el-option label="VR" value="VR" />
        </el-select>
      </el-form-item>
      <el-form-item label="分类" prop="category">
        <el-select
          :model-value="queryParams.category as any"
          @update:model-value="(val: any) => queryParams.category = val"
          class="!w-240px"
          clearable
          placeholder="请选择分类"
        >
          <el-option label="封面" value="COVER" />
          <el-option label="大堂" value="LOBBY" />
          <el-option label="客房" value="ROOM" />
          <el-option label="外观" value="EXTERIOR" />
          <el-option label="其他" value="OTHER" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
        <el-button
          v-hasPermi="['hotel:media:create']"
          plain
          type="primary"
          @click="openForm('create')"
        >
          <Icon class="mr-5px" icon="ep:plus" />
          新增
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column align="center" label="缩略图" prop="url">
        <template #default="scope">
          <el-image
            v-if="scope.row.url && scope.row.mediaType === 'IMAGE'"
            :src="scope.row.url"
            style="width: 60px; height: 40px"
          />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="标题" prop="title" min-width="150" />
      <el-table-column align="center" label="媒体类型" prop="mediaType">
        <template #default="scope">
          <el-tag v-if="scope.row.mediaType === 'IMAGE'" type="primary">图片</el-tag>
          <el-tag v-else-if="scope.row.mediaType === 'VIDEO'" type="success">视频</el-tag>
          <el-tag v-else-if="scope.row.mediaType === 'VR'" type="warning">VR</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="分类" prop="category">
        <template #default="scope">
          <el-tag v-if="scope.row.category === 'COVER'">封面</el-tag>
          <el-tag v-else-if="scope.row.category === 'LOBBY'" type="success">大堂</el-tag>
          <el-tag v-else-if="scope.row.category === 'ROOM'" type="primary">客房</el-tag>
          <el-tag v-else-if="scope.row.category === 'EXTERIOR'" type="warning">外观</el-tag>
          <el-tag v-else-if="scope.row.category === 'OTHER'" type="info">其他</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="排序" prop="sort" />
      <el-table-column align="center" label="封面" prop="isCover">
        <template #default="scope">
          <el-tag v-if="scope.row.isCover" type="danger">是</el-tag>
          <el-tag v-else type="info">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="创建时间"
        prop="createTime"
        width="180"
      />
      <el-table-column align="center" label="操作" width="220">
        <template #default="scope">
          <el-button
            v-hasPermi="['hotel:media:update']"
            link
            type="primary"
            @click="openForm('update', scope.row.id)"
          >
            修改
          </el-button>
          <el-button
            v-hasPermi="['hotel:media:delete']"
            link
            type="danger"
            @click="handleDelete(scope.row.id)"
          >
            删除
          </el-button>
          <el-button
            link
            type="success"
            @click="handleSetCover(scope.row)"
          >
            设为封面
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <Dialog v-model="dialogVisible" :title="dialogTitle">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="100px"
    >
      <el-form-item label="店铺" prop="shopId">
        <el-select v-model="formData.shopId" placeholder="请选择店铺" filterable clearable>
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="房型" prop="spuId">
        <el-select v-model="formData.spuId" placeholder="请选择房型" filterable clearable>
          <el-option v-for="item in roomList" :key="item.id" :label="item.roomNo || ('#' + item.id)" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="媒体类型" prop="mediaType">
        <el-select
          :model-value="formData.mediaType as any"
          @update:model-value="(val: any) => formData.mediaType = val"
          placeholder="请选择媒体类型"
        >
          <el-option label="图片" value="IMAGE" />
          <el-option label="视频" value="VIDEO" />
          <el-option label="VR" value="VR" />
        </el-select>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="formData.title" placeholder="请输入标题" />
      </el-form-item>
      <el-form-item label="URL地址" prop="url">
        <UploadImg
          v-model="formData.url"
          :width="'300px'"
          :height="'180px'"
          :file-size="10"
          :file-type="['image/jpeg','image/png','image/webp','image/gif','video/mp4']"
          directory="hotel/media"
        >
          <template #tip>支持 JPG/PNG/WEBP/GIF 图片以及 MP4 视频，≤ 10MB</template>
        </UploadImg>
      </el-form-item>
      <el-form-item label="分类" prop="category">
        <el-select
          :model-value="formData.category as any"
          @update:model-value="(val: any) => formData.category = val"
          placeholder="请选择分类"
        >
          <el-option label="封面" value="COVER" />
          <el-option label="大堂" value="LOBBY" />
          <el-option label="客房" value="ROOM" />
          <el-option label="外观" value="EXTERIOR" />
          <el-option label="其他" value="OTHER" />
        </el-select>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input-number
          v-model="formData.sort"
          :min="0"
          placeholder="请输入排序"
        />
      </el-form-item>
      <el-form-item label="设为封面" prop="isCover">
        <el-switch
          v-model="formData.isCover"
          active-text="是"
          inactive-text="否"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :loading="formLoading" type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import { dateFormatter } from '@/utils/formatTime'
import * as mediaApi from '@/api/hotel/media'
import { getShopSimpleList } from '@/api/hotel/platformShop'
import { listAllRooms } from '@/api/hotel/room'
import { CommonStatusEnum } from '@/utils/constants'
import UploadImg from '@/components/UploadFile/src/UploadImg.vue'

defineOptions({ name: 'HotelMedia' })

const message = useMessage()
const { t } = useI18n()

const loading = ref(true)
const total = ref(0)
const list = ref([])

const queryParams = reactive<any>({
  pageNo: 1,
  pageSize: 20,
  title: undefined,
  mediaType: undefined,
  category: undefined
})
const queryFormRef = ref()

const getList = async () => {
  loading.value = true
  try {
    const data = await mediaApi.getMediaPage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value.resetFields()
  handleQuery()
}

const dialogVisible = ref(false)
const dialogTitle = ref('')
const formLoading = ref(false)
const formType = ref('')
const formData = ref<mediaApi.MediaVO>({
  id: 0,
  shopId: undefined,
  spuId: undefined,
  mediaType: '',
  title: '',
  url: undefined,
  category: '',
  sort: 0,
  isCover: false,
  createTime: undefined as any
})
// 店铺下拉列表
const shopList = ref<any[]>([])
const getShopList = async () => {
  const data = await getShopSimpleList()
  shopList.value = data || []
}

// 房型(商品)下拉列表
const roomList = ref<any[]>([])
const getRoomList = async () => {
  const data = await listAllRooms()
  roomList.value = data.list || []
}

const formRules = reactive({
  title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
  mediaType: [{ required: true, message: '媒体类型不能为空', trigger: 'change' }],
  url: [{ required: true, message: '请上传文件', trigger: 'change' }]
})
const formRef = ref()

const openForm = async (type: string, id?: string | number) => {
  dialogVisible.value = true
  dialogTitle.value = t('action.' + type)
  formType.value = type
  resetForm()
  if (id) {
    formLoading.value = true
    try {
      formData.value = await mediaApi.getMedia(id)
    } finally {
      formLoading.value = false
    }
  }
}

const submitForm = async () => {
  if (!formRef) return
  const valid = await formRef.value.validate()
  if (!valid) return
  formLoading.value = true
  try {
    // 布尔值转 Integer (后端 isCover/sort 等字段都是 Integer)
    const data: any = { ...formData.value }
    if (typeof data.isCover === 'boolean') data.isCover = data.isCover ? 1 : 0
    if (data.sort !== undefined) data.sort = Number(data.sort)
    if (formType.value === 'create') {
      await mediaApi.createMedia(data)
      message.success(t('common.createSuccess'))
    } else {
      await mediaApi.updateMedia(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    await getList()
  } finally {
    formLoading.value = false
  }
}

const resetForm = () => {
  formData.value = {
    id: 0,
    shopId: undefined,
    spuId: undefined,
    mediaType: '',
    title: '',
    url: undefined,
    category: '',
    sort: 0,
    isCover: false,
    createTime: undefined as any
  }
  formRef.value?.resetFields()
}

const handleDelete = async (id: string | number) => {
  try {
    await message.delConfirm()
    await mediaApi.deleteMedia(id)
    message.success(t('common.delSuccess'))
    await getList()
  } catch {}
}

const handleSetCover = async (row: mediaApi.MediaVO) => {
  try {
    await message.confirm('确认将该媒体设为封面？')
    await mediaApi.updateSort({ id: row.id, isCover: 1 })
    message.success('设置成功')
    await getList()
  } catch {}
}

onMounted(() => {
  getList()
  getShopList()
  getRoomList()
})
</script>
